import * as types from './types';

export const removeAutofillValue = (data) => ({ type: types.REMOVE_AUTOFILL_VALUE, data });
export const removeAutofillRow = (data) => ({ type: types.REMOVE_AUTOFILL_ROW, data });
export const resetAutofill = (data) => ({ type: types.RESET_AUTOFILL, data });
export const setAutofill = (data) => ({ type: types.SET_AUTOFILL, data });
